"use client";

import { c as _c } from "react/compiler-runtime";
import { classNames, Media } from "@opensea/ui-kit";
import { useCollectionLayout } from "@/components/collection/CollectionLayoutProvider";
import { fullBleedVariants } from "@/styles/utils/page-container";
import { fixedHeroHeaderViewVariants, heroHeaderScrollOffsetVariants } from "./constants";
import { useHeroHeader } from "./HeroHeaderProvider";
function HeroHeaderLayoutBase(t0) {
  const $ = _c(30);
  const {
    headerView,
    headerViewScrollLocked,
    media,
    mediaClassName,
    children,
    backgroundChildren,
    isCollectionBanner: t1
  } = t0;
  const isCollectionBanner = t1 === undefined ? false : t1;
  const {
    setContainer
  } = useHeroHeader();
  const {
    isPreview
  } = useCollectionLayout();
  let t2;
  if ($[0] !== headerView || $[1] !== isCollectionBanner || $[2] !== isPreview) {
    t2 = classNames(fixedHeroHeaderViewVariants({
      headerView,
      isCollectionBanner
    }), "z-hero-header-content", headerView === "compact" ? isPreview ? "lg:fixed lg:right-0 lg:left-0 lg:w-full" : "lg:fixed lg:right-scroll-bar-size lg:left-side-nav lg:w-[calc(100%-theme(spacing.side-nav)-theme(spacing.scroll-bar-size))]" : "absolute");
    $[0] = headerView;
    $[1] = isCollectionBanner;
    $[2] = isPreview;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== children || $[5] !== t2) {
    t3 = <div className={t2}>{children}</div>;
    $[4] = children;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== isCollectionBanner || $[8] !== mediaClassName) {
    t4 = classNames(fixedHeroHeaderViewVariants({
      headerView: "full",
      isCollectionBanner
    }), "pointer-events-none top-0 z-hero-header-banner-media overflow-hidden", mediaClassName);
    $[7] = isCollectionBanner;
    $[8] = mediaClassName;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== media || $[11] !== t4) {
    t5 = <div className={t4}>{media}</div>;
    $[10] = media;
    $[11] = t4;
    $[12] = t5;
  } else {
    t5 = $[12];
  }
  let t6;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = classNames("pointer-events-none fixed inset-0 z-hero-header-background hidden w-full bg-bg-app lg:block", "h-[calc(theme(spacing.sm-top-nav)+theme(spacing.hero-header-compact))]", "lg:h-[calc(theme(spacing.lg-top-nav)+theme(spacing.hero-header-compact))]");
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== backgroundChildren) {
    t7 = <div className={t6}>{backgroundChildren}</div>;
    $[14] = backgroundChildren;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = headerViewScrollLocked ? headerView : "full";
  let t9;
  if ($[16] !== isCollectionBanner || $[17] !== t8) {
    t9 = heroHeaderScrollOffsetVariants({
      headerView: t8,
      isCollectionBanner
    });
    $[16] = isCollectionBanner;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t9) {
    t10 = <div className={t9} />;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = classNames(fullBleedVariants(), "dark md:-mt-4 bg-bg-app pb-1 md:pb-4 lg:hidden");
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  let t12;
  if ($[22] !== setContainer) {
    t12 = <div className={t11}><div className="mx-4 md:mx-6" ref={setContainer} /></div>;
    $[22] = setContainer;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== t10 || $[25] !== t12 || $[26] !== t3 || $[27] !== t5 || $[28] !== t7) {
    t13 = <div>{t3}{t5}{t7}{t10}{t12}</div>;
    $[24] = t10;
    $[25] = t12;
    $[26] = t3;
    $[27] = t5;
    $[28] = t7;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  return t13;
}
export function HeroHeaderLayout(props) {
  const $ = _c(7);
  let t0;
  if ($[0] !== props) {
    t0 = <Media greaterThanOrEqual="lg"><HeroHeaderLayoutBase {...props} /></Media>;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== props) {
    t1 = <Media lessThan="lg"><HeroHeaderLayoutBase {...props} headerView="full" /></Media>;
    $[2] = props;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== t0 || $[5] !== t1) {
    t2 = <>{t0}{t1}</>;
    $[4] = t0;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
}